import React from 'react';

import {AppContext} from '../../AppModule/Context';

import OpenWidgetComponent from './openWidgetComponent/openWidgetComponent';

import {ListeningRoomService} from '../../services/websocketService';
import postMessageService from '../../services/postMessageService';
import utilsService from '../../services/utilsService';

import VIDABOO_CONSTANTS from '../../config/consts';

class WidgetComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openWidget: this.props.isDemo ? true : false,
      peerClientInfo: {},
    };
  }

  componentDidMount = () => {
    // console.debug(30, this.props.mentor.mentorDto.appControlDto.style);
    if (!this.props.isDemo) {
      if (this.props.inTeamChatScenario) {
        utilsService.assignMentorCustomizationValues(
          Object.values(this.props.widgetDto.teamMentorsMapDto)[0]
            .extendedMentorDto.mentorDto.appControlDto.style,
          this.props.widgetDto.widgetAppCtrlDto.style,
        );
      } else {
        utilsService.assignMentorCustomizationValues(
          this.props.mentor.mentorDto.appControlDto.style,
          this.props.widgetDto.widgetAppCtrlDto.style,
        );
      }
    }
    // this.autoChatMessageTimeout = this.props.mentor.mentorDto.appControlDto
    //   .automaticChatMessageTime
    //   ? this.props.mentor.mentorDto.appControlDto.automaticChatMessageTime *
    //     1000
    //   : VIDABOO_CONSTANTS.CHAT_AUTO_RESPONDER
    //       .DEFAULT_TIME_BEFORE_AUTO_CHAT_POPS;
    // if (!this.props.isInAccount) this.startAutochatTimeout();

    if (this.props.actionClickData) {
      this.doUponParentRequest(this.props.actionClickData);
    } else {
      this.openCloseWidget();
      this.setInitialSelectedWidgetAppType();
    }

    this.deleteDoWhenMessageReceivedFromListeningRoom =
      ListeningRoomService.doWhenMessageReceivedFromListeningRoom((data) => {
        if (
          data.messageType === VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.CHAT &&
          data.senderUserId === this.props.mentor.mentorDto.mentorOwnerId
        ) {
          this.props.changeIframeSize &&
            !this.state.openWidget &&
            this.openCloseWidget(
              'visible',
              VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT,
            );
        }
      });
    const needToSendClientInfo = utilsService.checkIfNeedToSendPeerInfo(
      this.props.mentor?.mentorDto?.mentorId,
    );

    if (needToSendClientInfo) this.sendClientInfoMessage();
  };

  componentDidUpdate = (prevProps) => {
    if (this.context.callState !== this.callState && !this.props.isDemo) {
      this.callState = this.context.callState;
      if (this.context.callState !== VIDABOO_CONSTANTS.VIDEO_CALL_STATE.INIT) {
        this.props.onFooterOptionSelected(
          VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT,
        );
      }
    }
    // console.debug('Here now check to send info CU', this.props);
    // We need to check if:
    // 1. if the clientInfoMessage is received real-time when we're already open.

    const needToSendClientInfo = utilsService.checkIfNeedToSendPeerInfo(
      this.props.mentor?.mentorDto?.mentorId,
    );
    if (needToSendClientInfo) {
      // for real-time data recieved by an event triggered by customer's logic when in multi-widget.
      this.sendClientInfoMessage();
    }
    // if (
    //   this.props.clientInfoMessage &&
    //   this.props.actionClickData.clientInfo &&
    //   this.props.actionClickData.savedTime !==
    //     prevProps.actionClickData?.savedTime
    // ) {
    //   console.debug(
    //     'Here now check to send info CU',
    //     this.props.actionClickData,
    //   );
    //   this.checkIfNeedToSendPeerInfo(this.props.actionClickData);
    // }
    if (
      prevProps.actionClickData !== this.props.actionClickData &&
      this.props.actionClickData
    ) {
      this.doUponParentRequest(this.props.actionClickData);
    }
  };

  componentWillUnmount = () => {
    if (this.props.isInAccount) {
      this.openCloseWidget();
    }
    this.deleteDoWhenMessageReceivedFromListeningRoom();
    this.deleteAutoChatMessageTimeout &&
      clearTimeout(this.deleteAutoChatMessageTimeout);
  };

  setInitialSelectedWidgetAppType = () => {
    //if user directly opened the clickntalk page in mobile resolution then this.props.selectedWidgetAppType will be undefined
    if (!this.props.selectedWidgetAppType) {
      let selectedWidgetAppType =
        this.props.mentor.mentorDto.appControlDto.foregroundWidgets[0];
      if (!this.props.startValueFromQuery) {
        // widget case
        if (this.props.mentor.mentorDto.appControlDto.widgetActionSelector) {
          selectedWidgetAppType =
            VIDABOO_CONSTANTS.WIDGET_APP_TYPES.ACTION_SELECTOR;
        }
        if (this.props.bfi) {
          this.props.setSelectedWidgetAppType(
            VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WEBCALL,
          );
        } else {
          if (!this.props.selectedWidgetAppType) {
            this.props.setSelectedWidgetAppType(selectedWidgetAppType);
          }
        }
      } else {
        // clickntalk case
        // if selectedWidgetAppType is present, it means we first landed on clickntalk page and then we moved to widget view
        const searchUrl = window.location.search;
        if (searchUrl.includes('?')) {
          const widgetAppType = new URLSearchParams(searchUrl).get('start');
          if (widgetAppType) {
            selectedWidgetAppType =
              utilsService.getSelectedWidgetAppType(widgetAppType);
            if (
              selectedWidgetAppType === VIDABOO_CONSTANTS.WIDGET_APP_TYPES.NONE
            ) {
              selectedWidgetAppType =
                VIDABOO_CONSTANTS.WIDGET_APP_TYPES.ACTION_SELECTOR;
            }
          }
        }
        this.props.setSelectedWidgetAppType(selectedWidgetAppType);
      }
    } else if (
      this.props.selectedWidgetAppType ===
      VIDABOO_CONSTANTS.WIDGET_APP_TYPES.NONE
    ) {
      this.props.setSelectedWidgetAppType(
        VIDABOO_CONSTANTS.WIDGET_APP_TYPES.ACTION_SELECTOR,
      );
    }
  };

  sendClientInfoMessage = (clientInfo) => {
    // 1. Send data to peer
    // 2. in localStorage - remove the needToSend flag so we don't send this further.
    if (!clientInfo) {
      clientInfo = utilsService.getPeerClientInfo(
        this.props.mentor.mentorDto.mentorOwnerId,
        this.props.widgetDto,
      );
    }
    if (!clientInfo) return;
    const etAgentId = this.props.mentor.mentorDto.mentorId;
    if (this.openWdigetRef && this.openWdigetRef.callSendMessageFunc) {
      this.openWdigetRef.callSendMessageFunc(
        'Inbox Message',
        VIDABOO_CONSTANTS.CHAT_SUBTYPES.INFO_MESSAGE,
        JSON.stringify({
          createdTime: Date.now(),
          submissionPageUrl:
            postMessageService.getLocation()?.fullUrl ?? document.location.href,
          version: 'v2',
          recieverUserId: etAgentId,
          senderUserId: 'GUEST',
          subject: 'Name & Email of your potential client.',
          content: [
            {
              answers: clientInfo.email,
              field_name: 'email',
              questionType: VIDABOO_CONSTANTS.QUESTION_TYPE.EMAIL,
              title: 'Email',
            },
            {
              answers: clientInfo.name,
              field_name: 'name',
              questionType: VIDABOO_CONSTANTS.QUESTION_TYPE.SINGLE_LINE,
              title: 'Name',
            },
            {
              answers: clientInfo.phone_number,
              field_name: 'phone_number',
              questionType: VIDABOO_CONSTANTS.QUESTION_TYPE.PHONE_NUMBER,
              title: 'Phone',
            },
          ],
        }),
      );
    } else {
      const sendInfoInterval = setInterval(() => {
        if (this.openWdigetRef && this.openWdigetRef.callSendMessageFunc) {
          clearInterval(sendInfoInterval);
          this.openWdigetRef.callSendMessageFunc(
            'Inbox Message',
            VIDABOO_CONSTANTS.CHAT_SUBTYPES.INFO_MESSAGE,
            JSON.stringify({
              createdTime: Date.now(),
              submissionPageUrl:
                postMessageService.getLocation()?.fullUrl ??
                document.location.href,
              version: 'v2',
              recieverUserId: etAgentId,
              senderUserId: 'GUEST',
              subject: 'Name & Email of your potential client.',
              email: clientInfo?.email,
              senderFirstName: clientInfo?.senderFirstName,
              content: [
                {
                  answers: clientInfo?.email,
                  field_name: 'email',
                  questionType: VIDABOO_CONSTANTS.QUESTION_TYPE.EMAIL,
                  title: 'Email',
                },
                {
                  answers: clientInfo?.name,
                  field_name: 'name',
                  questionType: VIDABOO_CONSTANTS.QUESTION_TYPE.SINGLE_LINE,
                  title: 'Name',
                },
                {
                  answers: clientInfo?.phone_number,
                  field_name: 'phone_number',
                  questionType: VIDABOO_CONSTANTS.QUESTION_TYPE.PHONE_NUMBER,
                  title: 'Phone',
                },
              ],
            }),
          );
        }
      }, 500);
    }
    utilsService.updateNeedSendPeerInfo(false, etAgentId);
  };

  openCloseWidget = (visibility, selectedWidgetAppType) => {
    const newOpenWidgetState = this.props.isDemo
      ? true
      : !this.state.openWidget;
    if (newOpenWidgetState) {
      // widget will open
      this.props.dispatchConsoltoEvents &&
        this.props.dispatchConsoltoEvents(
          VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.OPEN_WIDGET,
        );
    } else {
      // widget will close
      this.sendGA(
        VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.CLOSE_WIDGET,
        this.props.mentor.mentorDto.profileName,
      );
      this.props.dispatchConsoltoEvents &&
        this.props.dispatchConsoltoEvents(
          VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.CLOSE_WIDGET,
        );
    }

    if (this.props.isInAccount) {
      // if (!newOpenWidgetState) this.props.openCloseWidget(); // only for closing when inside multi-widget and hit the close btn.
    } else {
      this.props.changeIframeSize &&
        this.props.changeIframeSize(
          newOpenWidgetState
            ? VIDABOO_CONSTANTS.WIDGET_SIZE.WIDGET_OPEN
            : VIDABOO_CONSTANTS.WIDGET_SIZE.WIDGET_CLOSED,
          'widget',
          visibility,
        );
      if (
        this.state.actionClickData &&
        !newOpenWidgetState &&
        !this.props.mentor.mentorDto.appControlDto.widgetVisible
      ) {
        postMessageService.postMessageHide('hidden', 'multiWidgetContainer');
      }
    }
    this.setState({
      openWidget: newOpenWidgetState,
    });
    if (selectedWidgetAppType) {
      this.props.setSelectedWidgetAppType(selectedWidgetAppType);
    }
  };
  sendGA = (eventAction, eventLabel) => {
    if (this.props.isDemo) return;
    this.props.sendGA(eventAction, eventLabel);
  };
  doUponParentRequest = (actionClickData) => {
    // To handle Single Expert widget
    // if (!this.props.isInAccount && actionClickData) {
    //   if (actionClickData.clientInfo) {
    //     // save info into localStorage
    //     actionClickData.peerUserId = this.props.mentor.mentorDto.mentorOwnerId;
    //     const needToSendClientInfo =
    //       utilsService.savePeerClientInfo(actionClickData);
    //     if (needToSendClientInfo) this.sendClientInfoMessage();
    //     this.setInitialSelectedWidgetAppType();
    //   }
    // }
    // Check if consolto start param available
    // TODO: Extract the logic to check if feature is enabled

    if (actionClickData && !utilsService.getIsPersonalPage()) {
      if (actionClickData.clientInfo) {
        if (
          actionClickData.etAgentId ===
          this.props.mentor.mentorDto.mentorOwnerId
        ) {
          // save info into localStorage
          actionClickData.mentorOwnerId =
            this.props.mentor.mentorDto.mentorOwnerId;
          actionClickData.mentorId = this.props.mentor.mentorDto.mentorId;
          const needToSendClientInfo = utilsService.savePeerClientInfo(
            actionClickData,
            this.props.widgetDto,
          );
          if (needToSendClientInfo) this.sendClientInfoMessage();
        }
        if (!actionClickData.etClickType && !actionClickData.etConsoltoStart) {
          this.openCloseWidget('visible');
          this.setInitialSelectedWidgetAppType();
        }
      }
      // If bfi is available then give priority to bfi
      else if (actionClickData.bfi) {
        this.setState({bfi: actionClickData.bfi});
        if (!this.state.openWidget) {
          this.openCloseWidget(
            'visible',
            VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WEBCALL,
          );
        } else {
          this.props.onFooterOptionSelected(
            VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WEBCALL,
          );
        }
        return;
      }
      // For video/ audio call
      if (
        (actionClickData.etConsoltoStart ===
          VIDABOO_CONSTANTS.TRIGGER_ACTIONS.AUDIO_CALL ||
          actionClickData.etConsoltoStart ===
            VIDABOO_CONSTANTS.TRIGGER_ACTIONS.VIDEO_CALL) &&
        this.props.mentor.mentorDto.appControlDto
          .requireContactDetailsForCall &&
        this.props.mentor.mentorDto.appControlDto.foregroundWidgets.findIndex(
          (w) => w === VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WEBCALL,
        ) === -1
      ) {
        if (!this.state.openWidget) {
          this.openCloseWidget(
            'visible',
            VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WEBCALL,
          );
        } else {
          this.props.onFooterOptionSelected(
            VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WEBCALL,
          );
        }
        if (
          this.state.actionClickData.etConsoltoStart ===
          VIDABOO_CONSTANTS.TRIGGER_ACTIONS.AUDIO_CALL
        ) {
          this.props.startVideochat({}, true, false);
        } else if (
          this.state.actionClickData.etConsoltoStart ===
          VIDABOO_CONSTANTS.TRIGGER_ACTIONS.VIDEO_CALL
        ) {
          this.props.startVideochat({}, false, false);
        }

        return;
      }
    }
    if (
      actionClickData.etClickType === 'start-chat' ||
      actionClickData.etConsoltoStart ===
        VIDABOO_CONSTANTS.TRIGGER_ACTIONS.TEXT_CHAT
    ) {
      if (!this.state.openWidget) {
        this.openCloseWidget(
          'visible',
          VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT,
        );
      } else {
        this.props.onFooterOptionSelected(
          VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT,
        );
      }
    } else if (
      actionClickData.etClickType === 'open-widget' ||
      actionClickData.etConsoltoStart ===
        VIDABOO_CONSTANTS.TRIGGER_ACTIONS.OPEN_WIDGET
    ) {
      if (!this.state.openWidget) {
        this.openCloseWidget('visible');
        this.setInitialSelectedWidgetAppType();
      }
    } else if (
      actionClickData.etClickType === 'start-call' ||
      actionClickData.etConsoltoStart ===
        VIDABOO_CONSTANTS.TRIGGER_ACTIONS.VIDEO_CALL
    ) {
      if (!this.state.openWidget) {
        this.openCloseWidget(
          'visible',
          VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WEBCALL,
        );
      } else {
        this.props.onFooterOptionSelected(
          VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WEBCALL,
        );
      }
    } else if (
      actionClickData.etClickType === 'start-audio-call' ||
      actionClickData.etConsoltoStart ===
        VIDABOO_CONSTANTS.TRIGGER_ACTIONS.AUDIO_CALL
    ) {
      if (!this.state.openWidget) {
        this.openCloseWidget(
          'visible',
          VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WEBCALL,
        );
      } else {
        this.props.onFooterOptionSelected(
          VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WEBCALL,
        );
      }
    } else if (
      actionClickData.etClickType === 'start-scheduling' ||
      actionClickData.etConsoltoStart ===
        VIDABOO_CONSTANTS.TRIGGER_ACTIONS.SCHEDULING
    ) {
      if (!this.state.openWidget) {
        this.openCloseWidget(
          'visible',
          VIDABOO_CONSTANTS.WIDGET_APP_TYPES.SCHEDULE_MEETING,
        );
      } else {
        this.props.onFooterOptionSelected(
          VIDABOO_CONSTANTS.WIDGET_APP_TYPES.SCHEDULE_MEETING,
        );
      }
    } else if (
      actionClickData.etClickType === 'start-form' ||
      actionClickData.etConsoltoStart ===
        VIDABOO_CONSTANTS.TRIGGER_ACTIONS.CONTACT_FORM
    ) {
      if (!this.state.openWidget) {
        this.openCloseWidget(
          'visible',
          VIDABOO_CONSTANTS.WIDGET_APP_TYPES.INFO_COLLECTOR,
        );
      } else {
        this.props.onFooterOptionSelected(
          VIDABOO_CONSTANTS.WIDGET_APP_TYPES.INFO_COLLECTOR,
        );
      }
    } else if (
      actionClickData.etClickType === 'start-fb-messenger' ||
      actionClickData.etConsoltoStart ===
        VIDABOO_CONSTANTS.TRIGGER_ACTIONS.FB_MESSENGER
    ) {
      if (!this.state.openWidget) {
        this.openCloseWidget(
          'visible',
          VIDABOO_CONSTANTS.WIDGET_APP_TYPES.FB_MESSENGER,
        );
      } else {
        this.props.onFooterOptionSelected(
          VIDABOO_CONSTANTS.WIDGET_APP_TYPES.FB_MESSENGER,
        );
      }
    } else if (
      actionClickData.etClickType === 'start-custom-link' ||
      actionClickData.etConsoltoStart ===
        VIDABOO_CONSTANTS.TRIGGER_ACTIONS.CUSTOM_LINK
    ) {
      if (!this.state.openWidget) {
        this.openCloseWidget(
          'visible',
          VIDABOO_CONSTANTS.WIDGET_APP_TYPES.CUSTOM_LINK,
        );
      } else {
        this.props.onFooterOptionSelected(
          VIDABOO_CONSTANTS.WIDGET_APP_TYPES.CUSTOM_LINK,
        );
      }
    } else if (
      actionClickData.etClickType === 'start-whatsapp' ||
      actionClickData.etConsoltoStart ===
        VIDABOO_CONSTANTS.TRIGGER_ACTIONS.WHATSAPP
    ) {
      if (!this.state.openWidget) {
        this.openCloseWidget(
          'visible',
          VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WHATSAPP,
        );
      } else {
        this.props.onFooterOptionSelected(
          VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WHATSAPP,
        );
      }
    } else if (
      actionClickData.etClickType === 'start-phonecall' ||
      actionClickData.etConsoltoStart ===
        VIDABOO_CONSTANTS.TRIGGER_ACTIONS.PHONE_CALL
    ) {
      if (!this.state.openWidget) {
        this.openCloseWidget(
          'visible',
          VIDABOO_CONSTANTS.WIDGET_APP_TYPES.PHONE_CALL,
        );
      } else {
        this.props.onFooterOptionSelected(
          VIDABOO_CONSTANTS.WIDGET_APP_TYPES.PHONE_CALL,
        );
      }
    }
  };

  render() {
    // console.debug("mentoor value is", this.props.mentor);
    // console.debug(this.props.mentor);

    return (
      this.state.openWidget && (
        <OpenWidgetComponent
          ref={(ref) => (this.openWdigetRef = ref)}
          startVideochat={this.props.startVideochat}
          sessionTemplate={this.props.sessionTemplate}
          canMoveToTeamChat={this.props.canMoveToTeamChat}
          isDemo={this.props.isDemo}
          isEntireWidgetHidden={this.props.isEntireWidgetHidden}
          isMultiWidget={this.props.isMultiWidget}
          inTeamChatScenario={this.props.inTeamChatScenario}
          openCloseWidget={this.openCloseWidget}
          onFooterOptionSelected={this.props.onFooterOptionSelected}
          startChat={this.props.startChat}
          widgetDto={this.props.widgetDto}
          widgetProfileImage={this.props.widgetProfileImage}
          mentor={this.props.mentor}
          mentorProfileImage={this.props.mentorProfileImage}
          // startChatWithPeer={this.props.startChatWithPeer}
          startChatObj={this.props.startChatObj}
          selectedWidgetAppType={this.props.selectedWidgetAppType}
          postCallFail={this.props.postCallFail}
          dispatchConsoltoEvents={this.props.dispatchConsoltoEvents}
          enableWidgetAnalyticsForward={this.props.enableWidgetAnalyticsForward}
          // callbackSuccessInfoSend={this.callbackSuccessInfoSend}
          actionClickData={this.props.actionClickData}
          doWhenActionClick={this.props.doWhenActionClick}
          resetActionClickData={this.props.resetActionClickData}
          startValueFromQuery={this.props.startValueFromQuery}
          bfi={this.state.bfi ? this.state.bfi : this.props.bfi}
          showNotificationPopupForWait={this.props.showNotificationPopupForWait}
          clearAutomatedCallLoop={this.props.clearAutomatedCallLoop}
          isClearedManually={this.props.isClearedManually}
          permissionsStatusesObj={this.props.permissionsStatusesObj}
          setShowPermissionsPopup={this.props.setShowPermissionsPopup}
          setPermissionsStatusesObj={this.props.setPermissionsStatusesObj}
          handlePermissionsSuccess={this.props.handlePermissionsSuccess}
          setIsCallAudioOnly={this.props.setIsCallAudioOnly}
          isAutomatedCallHandled={this.props.isAutomatedCallHandled}
          setIsAutomatedCallHandled={this.props.setIsAutomatedCallHandled}
          onHeaderBackButton={this.props.onHeaderBackButton}
          onHeaderCloseButton={this.props.onHeaderCloseButton}
        />
      )
    );
  }
}

WidgetComponent.contextType = AppContext;
export default WidgetComponent;
